export const VerificationSubTypeEnum = {
    BANKID: "bankid",
    SUMSUB: "sumsub",
} as const;
